import Vue from "vue";
import VueRouter from "vue-router";
import { CAMPAIGN_100years, CAMPAIGN_100years_returning } from "./utm";

import index from "./views/_index";
import agb from "./views/agb";
import career from "./views/career";
import contact from "./views/contact";
import education from "./views/education";
import features from "./views/features";
import hotline from "./views/hotline";
import impressum from "./views/impressum";
import constructionWebinar from "./views/landingpages/construction-webinar";
import discover from "./views/landingpages/discover";
import freebeer from "./views/landingpages/freebeer";
import serviceplanner from "./views/landingpages/serviceplanner";
import meeting from "./views/meeting";
import pricing from "./views/pricing";
import privacy from "./views/privacy";
import returned from "./views/returned";
import voucher from "./views/voucher";

Vue.use(VueRouter);

const routes = [
  {
    path: "/karriere",
    redirect: "/de/karriere",
  },
  {
    path: "/career",
    redirect: "/en/career",
  },
  {
    path: "/inhalte",
    redirect: "/de/inhalte",
  },
  {
    path: "/features",
    redirect: "/de/features",
  },
  {
    path: "/meeting",
    redirect: "/en/meeting",
  },
  {
    path: "/agb",
    redirect: "/de/agb",
  },
  {
    path: "/terms",
    redirect: "/en/terms",
  },
  {
    path: "/preise",
    redirect: "/de/preise",
  },
  {
    path: "/pricing",
    redirect: "/en/pricing",
  },
  {
    path: "/kontakt",
    redirect: "/de/kontakt",
  },
  {
    path: "/contact",
    redirect: "/en/contact",
  },
  {
    path: "/impressum",
    redirect: "/de/impressum",
  },
  {
    path: "/imprint",
    redirect: "/en/imprint",
  },
  {
    path: "/datenschutz",
    redirect: "/de/datenschutz",
  },
  {
    path: "/privacy",
    redirect: "/en/privacy",
  },
  {
    path: "/wartung",
    redirect: "/de/wartung",
  },
  {
    path: "/serviceplanner",
    redirect: "/en/serviceplanner",
  },
  {
    path: "/education",
    redirect: "/de/education",
  },
  {
    path: "/hotline",
    redirect: "/de/hotline",
  },
  {
    path: "/voucher",
    redirect: "/en/voucher",
  },
  {
    path: "/gutscheincode",
    redirect: "/de/gutscheincode",
  },
  {
    path: "/discover",
    redirect: "/en/discover",
  },
  {
    path: "/entdecken",
    redirect: "/de/entdecken",
  },
  {
    path: "/construction-webinar",
    redirect: "/en/construction-webinar",
  },
  {
    path: "/baumaschinen-webinar",
    redirect: "/de/baumaschinen-webinar",
  },
  {
    path: "/freibier",
    redirect: () => {
      return {
        path: "/de/freibier",
        query: CAMPAIGN_100years,
      };
    },
  },
  {
    path: "/100jahre",
    redirect: () => {
      return {
        path: "/de/freibier",
        query: CAMPAIGN_100years,
      };
    },
  },
  {
    path: "/100-jahre",
    redirect: () => {
      return {
        path: "/de/freibier",
        query: CAMPAIGN_100years,
      };
    },
  },
  {
    path: "/fricke100",
    redirect: () => {
      return {
        path: "/de/gutscheincode",
        query: CAMPAIGN_100years_returning,
      };
    },
  },
  {
    path: "/fricke-100",
    redirect: () => {
      return {
        path: "/de/gutscheincode",
        query: CAMPAIGN_100years_returning,
      };
    },
  },
  {
    path: "/:locale/karriere",
    name: "career",
    component: career,
  },
  {
    path: "/:locale/career",
    name: "career",
    component: career,
  },
  {
    path: "/:locale/inhalte",
    name: "features",
    component: features,
  },
  {
    path: "/:locale/features",
    name: "features",
    component: features,
  },
  {
    path: "/:locale/meeting",
    name: "meeting",
    component: meeting,
  },
  {
    path: "/:locale/returned",
    name: "returned",
    component: returned,
  },
  {
    path: "/:locale/agb",
    name: "agb",
    component: agb,
  },
  {
    path: "/:locale/terms",
    name: "terms",
    component: agb,
  },
  {
    path: "/:locale/preise",
    name: "pricing",
    component: pricing,
  },
  {
    path: "/:locale/pricing",
    name: "pricing",
    component: pricing,
  },
  {
    path: "/:locale/contact",
    name: "contact",
    component: contact,
  },
  {
    path: "/:locale/kontakt",
    name: "contact",
    component: contact,
  },
  {
    path: "/:locale/impressum",
    name: "impressum",
    component: impressum,
  },
  {
    path: "/:locale/imprint",
    name: "imprint",
    component: impressum,
  },
  {
    path: "/:locale/datenschutz",
    name: "privacy",
    component: privacy,
  },
  {
    path: "/:locale/privacy",
    name: "privacy",
    component: privacy,
  },
  {
    path: "/:locale/serviceplanner",
    name: "serviceplanner",
    component: serviceplanner,
  },
  {
    path: "/:locale/education",
    name: "education",
    component: education,
  },
  {
    path: "/:locale/hotline",
    name: "hotline",
    component: hotline,
  },
  {
    path: "/:locale/gutscheincode",
    name: "voucher",
    component: voucher,
  },
  {
    path: "/:locale/voucher",
    name: "voucher",
    component: voucher,
  },
  {
    path: "/:locale/entdecken",
    name: "discover-now",
    component: discover,
  },
  {
    path: "/:locale/discover",
    name: "discover-now",
    component: discover,
  },
  {
    path: "/:locale/baumaschinen-webinar",
    name: "construction-webinar",
    component: constructionWebinar,
  },
  {
    path: "/:locale/construction-webinar",
    name: "construction-webinar",
    component: constructionWebinar,
  },
  {
    path: "/:locale/freibier",
    name: "100-jahre-fricke",
    component: freebeer,
  },
  {
    path: "/:locale/100jahre",
    redirect: () => {
      return {
        path: "/:locale/freibier",
        query: CAMPAIGN_100years,
      };
    },
  },
  {
    path: "/:locale/100-jahre",
    redirect: () => {
      return {
        path: "/:locale/freibier",
        query: CAMPAIGN_100years,
      };
    },
  },
  {
    path: "/:locale/fricke100",
    redirect: () => {
      return {
        path: "/:locale/voucher",
        query: CAMPAIGN_100years_returning,
      };
    },
  },
  {
    path: "/:locale/fricke-100",
    redirect: () => {
      return {
        path: "/:locale/voucher",
        query: CAMPAIGN_100years_returning,
      };
    },
  },
  {
    path: "/:locale",
    name: "index",
    component: index,
  },
  {
    path: "/",
    redirect: "/de",
  },
  {
    path: "*",
    name: "404",
    redirect: "/",
  },
];
const router = new VueRouter({
  mode: "history",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  base: process.env.BASE_URL,
  routes,
});

const hasQueryParams = (route) => !!Object.keys(route.query).length;

router.beforeEach((to, from, next) => {
  if (!hasQueryParams(to) && hasQueryParams(from)) {
    next({ name: to.name, query: from.query });
  } else {
    next();
  }
});

export default router;
